import { z } from 'zod'

export const pausePlanProgressSteps = ['Set pause', 'Review']

export const DATE_FORMAT = 'HH:mm on D MMMM YYYY'

export const previewPauseFormSchema = z.object({
  startDate: z.string().min(1, 'Start date is required'),
  pauseLengthWeeks: z
    .number()
    .min(1, 'Pause length must be at least 1 week')
    .max(2, 'Pause length cannot exceed 2 weeks'),
})
